// AI Expense用のテーマカラー
export const AI_EXPENSE_COLORS = {
  brand: {
    primary: '#2592C8',
    hover: '#1E7BA3'
  },
  danger: {
    primary: '#C72F62',
    hover: '#A0254E'
  }
} as const;
